import React, {Fragment} from 'react';
import { FormItemBase } from "../FormUI";
import PatientService from "../../api/services/PatientService";
import User from "../../api/User";
import Highlight from 'react-highlighter';
import AutoCompleteInput from "../AutoCompleteInput";
import UserMiniForm from '../../views/Clients/forms/UserMiniForm';
import BiopedModal, { ActionModal } from '../BioPedModal';
import './ClinicPatientList.css';
import UserDetails, { DetailCard } from '../../views/Clients/UserDetails';
import UserForm from '../../views/Clients/forms/UserForm';

const userPropNames = {
    'cellPhone': 'C',
    'homePhone': 'H',
    'workPhone': 'W',
    'email': 'E',
}
export default class ClinicPatientList extends FormItemBase{
    state = {};
    acRef = {};
    createModalTitle = 'New Patient';
    constructor(props){
        super(props);
        this.filterOption = this.filterOption.bind(this);
        this.optionRenderer = this.optionRenderer.bind(this);
    }

    get service(){
        return this.props.service || PatientService;
    }


    filterOption(option, filter){
        return true;//option;// this.getMatchingProps(option, filter);
    }

    getMatchingProps(user, search, getList){
        let compareProps = ['fullName', 'homePhone','cellPhone', 'workPhone', 'email', 'address1', 'address2'];
        let found = [];
        let s = search.toLowerCase();
        for(let i=0; i < compareProps.length; i++){
            let val = user[compareProps[i]];
            if(val){                          
                if(val.toLowerCase().indexOf(s) !== -1){
                    if(getList){
                        found.push(compareProps[i]);
                    }else{
                        return true;
                    }  
                } 
            }            
        }

        
        return getList? found:false;
    }

    optionRenderer(option, index, filter){
            //console.log("Option Render:", option);
        
            let user = option;
            let matchingProps = this.getMatchingProps(option, filter, true);
            let addressUsed = false;
            let o = [];
            let matchedProps = {};
            for(let i=0; i < matchingProps.length; i++){
                let p = matchingProps[i];
                matchedProps[p] = true;
                if(p !== 'fullName'){
                    switch(p){
                        case 'address1':
                        case 'address2':
                            if(addressUsed)continue;
                            o.push(
                                <div>
                                    <div>Address</div>
                                    <div><Highlight search={filter}>{option['address1']}</Highlight> </div>
                                    <div><Highlight search={filter}>{option['address2']}</Highlight> </div>
                                </div>
                            )
                            addressUsed = true;
                        break;
                        default:
                            o.push(<div>{userPropNames[p] || p} :<Highlight search={filter}>{option[p]}</Highlight> </div>);
                        break;
                    }
                    
                }                
            }

            let hangerVal = User.GetContact(option);
            let hanger;
            if(hangerVal && !matchedProps[hangerVal.name]){
                hanger = <span className='name-hanger'> - {userPropNames[hangerVal.name] + ':' + hangerVal.value}</span>;
            }

            return <div>
                        <span><Highlight search={filter}>{option.fullName}</Highlight></span>{hanger}
                        {o}
                    </div>;
        
        //return option.fullName;
    }


    getSingle = (patientId) => {
        return this.service.GetById(patientId).then((client) =>{
            return new User(client);
        });
    }

    getSearch = (term) => {
        if(!term.trim())return Promise.resolve([]);
        return this.service.Search(term).then((json) => {
            return json.map((user) => new User(user));
        })
    }

    formatResultForOptions = (json) =>{
        let options = [];
        for(let i=0; i < json.length; i++){
            options.push(new User(json[i]));
        }
        return {options:options};
    }

    getOptions = (input) =>{


        return this.getSearch(input);
    }

    handleOnChange = (val) =>{
        this.setState({options:[val]});
        if(this.props.onChange){
            this.props.onChange(val)
        }
    }

    valueRenderer = (user) => {
        return user.fullName;
    }


    handleOptionSelect = (user, skipCB)=>{
        this.setState({user:user});
        this._onValueChanged(user.clientId, true);
        if(this.props.onOptionSelect && !skipCB){
            this.props.onOptionSelect(user);
        }
    }

    componentDidMount(){
        if(this.props.user){
            this.handleOptionSelect(this.props.user, true);
        }

        //console.log("CLinic List Loaded value:", this.value);

        if(this.value){
            this.getSingle(this.value).then((user)=>{
                console.log("getSingle:", user)
                this.setState({user:user});
                if(this.acRef){
                    this.acRef.setOption(user);
                }
            })
        }
    }

    showCreatePatientForm = (option)=>{
        console.log("Create New Patient", option);
        let fullName = option.split(' ');

        this.setState({showCreatePatient:true, newPatient:{
            firstName:fullName[0] || '',
            lastName: fullName[1] || ''
        }})
    }
    
    handleNewPatientCreated = (user)=>{
        console.log("New PatientCreated:", user);
        this.handleOptionSelect(user);
        if(this.acRef){
            this.acRef.setOption(user);
        }
        this.setState({showCreatePatient:false});
    }

    showUserDetails = ()=>{
        this.setState({showDetails:true})
    }
    
    handleEdit = () =>{
        this.setState({showEdit:true, showDetails:false});
    }

    render(){
        let {reload, onLoaded, options, form, onOptionSelect, onNewOptionClick, ...props} = this.props;
        let label = (this.state.user || {}).fullName || '';
        let userDetails = (this.state.user? <span className='btn-view-user-details' onClick={this.showUserDetails}>View Details</span>:null)
        
        console.log("User Label:", label)

        let MiniForm = this.props.miniForm || UserMiniForm;
        let UserDetailCard = this.props.detailCard || DetailCard;
        console.log("Detail Card:", UserDetailCard);
        return(
            <Fragment>
                <AutoCompleteInput bottomStatus={userDetails} value={this.state.user} ref={(r) => this.acRef=r} onOptionSelect={this.handleOptionSelect} onNewOptionClick={this.showCreatePatientForm} loadOptions={this.getOptions} valueRenderer={this.valueRenderer} optionRenderer={this.optionRenderer} {... props} />
                <ActionModal title={this.props.createModalTitle || this.createModalTitle} close='Cancel'  isOpen={this.state.showCreatePatient} onRequestClose={() => this.setState({showCreatePatient:false})}>
                    <MiniForm user={this.state.newPatient} onSaved={this.handleNewPatientCreated} service={this.service} />
                </ActionModal>
                <BiopedModal isOpen={this.state.showDetails} onRequestClose={() => this.setState({showDetails:false})}>
                    <UserDetails hideEdit={this.props.hideEdit} user={this.state.user} backCaption='Close' onBack={() => this.setState({showDetails:false})} onEdit={this.handleEdit} />
                </BiopedModal>
                <ActionModal close='Close' title='Edit Patient' className='scrollable' isOpen={this.state.showEdit} onRequestClose={() => this.setState({showEdit:false})}>
                    <UserForm className='popup-form' user={this.state.user} onBack={() => this.setState({showEdit:false})} />
                </ActionModal>
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/datalists/ClinicPatientList.js